<template>
  <span>
    <span v-if="size === 'tiny'">
      <span v-if="typeof name === 'undefined' || name === 'devis-b2b'" class="label label-primary">B2B</span>
      <span v-if="typeof name === 'undefined' || name === 'communication'" class="label lable-purple">COM</span>
      <span v-if="typeof name === 'undefined' || name === 'sellsy'" class="label label-pink">SEL</span>
      <span v-if="typeof name === 'undefined' || name === 'sellsy-comweb'" class="label label-pink">SEL.C</span>
      <span v-if="typeof name === 'undefined' || name === 'commercial-app'" class="label label-warning">APP</span>
    </span>
    <span v-else>
      <span v-if="typeof name === 'undefined' || name === 'devis-b2b'">Devis B2B</span>
      <span v-if="typeof name === 'undefined' || name === 'communication'">Communication</span>
      <span v-if="typeof name === 'undefined' || name === 'sellsy'">Sellsy</span>
      <span v-if="typeof name === 'undefined' || name === 'sellsy-comweb'">Sellsy ComWeb</span>
      <span v-if="typeof name === 'undefined' || name === 'commercial-app'">APP Commercial</span>
    </span>
  </span>
</template>

<script>
  export default {
    name: 'source-app',
    props: ['name', 'size']
  }
</script>



// WEBPACK FOOTER //
// SourceApp.vue?e61bcf02